import { debounce } from 'throttle-debounce';

export class WidgetStatePublisher<T> {
  params: Partial<T> = {};

  debouncedOnChange?: debounce<(params: Partial<T>) => void>;

  constructor(
    initParams: Partial<T>,
    private onChange?: (params: Partial<T>) => void,
  ) {
    Object.assign(this.params, initParams);
    this.setParams = this.setParams.bind(this);
    if (this.onChange) {
      this.debouncedOnChange = debounce(1000, this.onChange);
    }
  }

  debouncedSetParams(params: Partial<T>) {
    Object.assign(this.params, params);
    if (this.debouncedOnChange) {
      this.debouncedOnChange({ ...this.params });
    }
  }

  setParams(params: Partial<T>) {
    Object.assign(this.params, params);
    this.debouncedOnChange?.cancel({ upcomingOnly: true });
    if (this.onChange) {
      this.onChange({ ...this.params });
    }
  }

  replaceParams(params: Partial<T>) {
    Object.assign(this.params, params);
  }
}
